module.exports = __webpack_public_path__ + "static/media/newHomeHero.6df9b544.png";